import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';
import { LoginComponent } from '../../../auth/login/login.component';
import { AuthService } from '../../../auth/auth.service';
import { environment } from '../../../../environments/environment';
import { DashboardComponent } from '../../../features/dashboard/dashboard.component';

@Component({
    selector: 'app-home',
    standalone: true,
    imports: [CommonModule, LoginComponent, DashboardComponent],
    templateUrl: './home.component.html',
    styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit, OnDestroy {
  private authService = inject(AuthService);
  private readonly _destroying$ = new Subject<void>();
  
  isAuthenticated = false;
  useMockAuth = environment.useMockAuth;

  ngOnInit() {
    // Subscribe to authentication state changes from AuthService
    this.authService.isAuthenticated$
      .pipe(takeUntil(this._destroying$))
      .subscribe((isAuthenticated) => {
        this.isAuthenticated = isAuthenticated;
      });
  }

  ngOnDestroy(): void {
    this._destroying$.next();
    this._destroying$.complete();
  }
}
